const Pills = () => {
  return (
    <div className="w-full h-5 relative rounded-981xl bg-brand-brand-primary flex flex-row items-center justify-center pt-0 px-0 pb-px box-border text-left text-smi text-base-white font-text-xl-semibold">
      <div className="relative tracking-[0.04em] leading-[19px] font-semibold">
        4
      </div>
    </div>
  );
};

export default Pills;
